import React, { useContext, useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faClock } from '@fortawesome/free-solid-svg-icons';
import { DataContext } from '../contexts/DataContext';

const ShipmentTimingCard = () => {
  const { shipments } = useContext(DataContext);
  const [atRiskCount, setAtRiskCount] = useState(0);
  const [inTimeCount, setInTimeCount] = useState(0);

  useEffect(() => {
    // Compute counts for at-risk and in-time shipments
    let atRisk = 0;
    let inTime = 0;
    shipments.forEach(shipment => {
      if (shipment.jobStatus !== "CMP") {
        const consolAtd = new Date(shipment.consolAtd);
        const originEtd = new Date(shipment.originEtd);
        if (consolAtd > originEtd) {
          atRisk += 1;
        } else if (consolAtd.getTime() === originEtd.getTime()) {
          inTime += 1;
        }
      }
    });

    setAtRiskCount(atRisk);
    setInTimeCount(inTime);
  }, [shipments]);

  return (
    <div className="bg-white shadow rounded-lg p-6 w-full max-w-lg h-custom-card-small">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-bold text-gray-800 flex items-center">
          <FontAwesomeIcon icon={faClock} className="text-blue-600 mr-3" />
          Shipment Timing
        </h2>
        <a href="/shipment-timing" className="text-md text-blue-600 hover:text-blue-800 transition duration-300">
          View details
        </a>
      </div>
      <div className="grid grid-cols-2 divide-x divide-gray-200 text-center">
        <div className="px-4 py-2">
          <FontAwesomeIcon icon={faExclamationTriangle} className="text-yellow-500 text-3xl mb-2" />
          <p className="text-md text-gray-600">At Risk</p>
          <p className="text-2xl font-semibold text-gray-800">{atRiskCount}</p>
        </div>
        <div className="px-4 py-2">
          <FontAwesomeIcon icon={faClock} className="text-green-600 text-3xl mb-2" />
          <p className="text-md text-gray-600">In Time</p>
          <p className="text-2xl font-semibold text-gray-800">{inTimeCount}</p>
        </div>
      </div>
    </div>
  );
};

export default ShipmentTimingCard;
